import { Component, Input, OnInit } from '@angular/core';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SharedHttpService } from '../../services/shared-http.service';
import { CaseService } from '../../services/case.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-facts-only',
  templateUrl: './facts-only.component.html',
  styleUrls: ['./facts-only.component.scss']
})
export class FactsOnlyComponent implements OnInit {

  caseFactList: any;
  closeResult: string = '';
  factId: any;
  factIdEdit: any;
  descriptionEdit: any;
  factcaseEdit: any;
  reasonId: any;
  reasonIdEdit: any;
  descriptionReasonEdit: any;
  reasoncaseEdit: any;
  factItem: any;
  caseStatusId: any;

  constructor(private modalService: NgbModal, public sharedService: SharedHttpService,  public caseService: CaseService) { }
  @Input() loadDataFP: Observable<any>;

  facts: any = [];
  factsBool: Boolean[] = []

  casefacts: string = "";
  caseObject: any;


  fact: any = "";
  showDeleteFactButton = false;
  selectedFact;

  showDeleteReasonButton = false;
  selectedReason;




  ngOnInit(): void {
      this.loadDataFP.subscribe((data) => {
          setTimeout(() => {
this.loadData();
          }, 100);

      });


  }



  loadData() {
      this.caseObject = this.caseService.getCaseData();
      console.log("lolo",this.caseObject);
      // this.caseStatusId =this.caseObject.caseStatusId;
      this.sharedService.get(`api/Fact/GetAll?skip=0&take=1500`).subscribe(res => {
          this.facts = res.data;
          this.facts.map(fact => {
              if (this.casefacts.indexOf(fact.description) != -1) {
                  fact.added = true;
              } else {
                  fact.added = false;
              }
          })

      });

    
      this.casefacts = this.caseObject.facts;
      if (this.casefacts == null) {
          this.casefacts = "";
      }

      this.sharedService.get(`api/CaseFact/GetAll?skip=0&take=1500&Filter.Filters[0].operator=eq&Filter.Filters[0].value=${this.caseObject.caseId}&Filter.Filters[0].field=caseId`).subscribe(res => {
          this.caseFactList = res.data;
          console.log("caseFactList", this.caseFactList);
      });
  }

  addFact(mymodal) {
      this.open(mymodal);
  }
  
  clear(){ 
    this.casefacts='';
    this.fact='';
    this.modalService.dismissAll();
  }

  onAddFact() {
      this.sharedService.post("api/CaseFact/Insert", [
          {
              "factId": this.selectedFact.factId,
              "description": this.casefacts,
              "caseId": this.caseObject.caseId
          }
      ]
      ).subscribe((response) => {
          this.sharedService.showSuccessKey("CreatedSuccessfully");
         this.modalService.dismissAll();

          this.loadData();
      },
          (error) => {
              console.error('error')
              this.sharedService.showErrorKey("Notsaved");
          });

  }
  
  UpdateFact(item,mymodal) {
      console.log('factItem',item);
      
      this.factItem=item;
      this.factIdEdit=item.factId;
      this.descriptionEdit=item.description;
      this.factcaseEdit=item.caseFactId;
      this.open(mymodal);
  }

  factSelectedEdit(e){
      if (e) {
          this.factIdEdit=e.factId;    
      }
      
      this.facts.map(f => {
          if (f.description == e.description) {
              f.added = true;
          }

      })
   if (this.descriptionEdit != "" && this.descriptionEdit != null)
          this.descriptionEdit =  e.description;
      else
          this.descriptionEdit = e.description;

  }
  onUpdateFact() {
      let updateUrl='api/CaseFact/Update';
      let objectBody={'caseFactId':this.factcaseEdit,'factId':this.factIdEdit,'description':this.descriptionEdit,"caseId": this.caseObject.caseId};
      this.sharedService.put(updateUrl,[objectBody]
      ).subscribe((response) => {
          this.sharedService.showSuccessKey("EditedSuccessfully");
          this.modalService.dismissAll();

          this.loadData();
      },
          (error) => {
              console.error('error')
              // this.toastr.showError(this.sharedService.getTranslatedKey("Notsaved"), this.sharedService.getTranslatedKey("Success"));


          });

  }
  
  DeleteFact(factId: any, mymodal) {
      this.openDel(mymodal);
      this.factId = factId;

  }

  onDeleteFact() {
      let url = 'api/CaseFact/Delete'
      this.sharedService.delete(url, [this.factId]).subscribe(

          (response) => {
              this.sharedService.showSuccessKey("DeletedSuccessfully");
              this.modalService.dismissAll();

              this.loadData();
          },
          (error) => {
              console.error('error')
              this.sharedService.showErrorKey("Notsaved");
          });
  }

  openDel(content: any) {

      this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', centered: true }).result.then((result) => {
        this.closeResult = `Closed with: ${result}`;
      }, (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
     
      });
    }

  open(content: any) {

      this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', centered: true,size: 'lg' }).result.then((result) => {
          this.closeResult = `Closed with: ${result}`;
      }, (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });
  }


  private getDismissReason(reason: any): string {
      if (reason === ModalDismissReasons.ESC) {
          return 'by pressing ESC';
      } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
          return 'by clicking on a backdrop';
      } else {
          return `with: ${reason}`;
      }
  }
 
  factSelected(e) {
      if (e) {
          this.selectedFact = e;
      }
      this.facts.map(f => {
          if (f.description == this.fact) {
              f.added = true;
          }
      })
      if (this.casefacts != "" && this.casefacts != null)
          this.casefacts =  this.fact;
      else
          this.casefacts = this.fact;
  }
  


}
